export default __webpack_public_path__ + "static/media/facebook.a8e19816.svg";